import { formatEventDates } from './utils/date-utils';
import { getToken } from './api/generateToken';
import { getDictionary } from './api/getDictionary';
import { CoveoAnalyticsClient } from 'coveo.analytics/modules';
import { SearchConfigurationOptions, SearchEngineConfiguration, loadQuerySetActions, buildSearchEngine } from '@coveo/headless';

async function main() {
  //console.log('-----------------------------called main function -----------------------------');
  //var storeOneTrustValue = [];

  const currentPath = document.querySelector(".pagename");
  
  await customElements.whenDefined('atomic-search-interface');
  const searchInterface: HTMLAtomicSearchInterfaceElement =
    document.querySelector('atomic-search-interface')!;

  const pageId = document.body.dataset.pageId as string;
  const currentLanguage = document.documentElement.lang as string;

  const tokenData = await getToken(currentLanguage, pageId);
  const dictionaryData = await getDictionary(currentLanguage, pageId);
  const isSearch = document.body.dataset.coveoSearch?.toLowerCase() === 'true';
  const isUserOnSearchPage = document.body.dataset.useronSearchpage?.toLowerCase() === 'true';
  const currentTemplate = document.body.dataset.templatename as string;
  const accessToken = tokenData.token!;
  const organizationId = tokenData.organizationId!;

  // early return if we're not on search page
  if (!isSearch) return;

  const search: SearchConfigurationOptions = {
    preprocessSearchResponseMiddleware: (response: any) => {
      response.body.results.forEach((result: any) => {
        result.raw.eventformatteddate = formatEventDates(
          currentLanguage,
          result.raw.commondate as never,
          result.raw.endz32xdate as never
        );
        return result;
      });
      return response;
    },
    preprocessFacetSearchResponseMiddleware: (response: any) => response,
    preprocessQuerySuggestResponseMiddleware: (response: any) => response,
  };
  const config: SearchEngineConfiguration = {
    accessToken,
    organizationId,
    // only add search field to config if we're on search page
    ...(isSearch ? { search } : {}),
  };

  //** started search activity from here */
  if (!currentPath) {
    await searchInterface.initialize(config); //initiali search 
  }

  var pattern = RegExp('OptanonConsent' + "=.[^;]*");
  const re = new RegExp('(.*?):(.*?)(?:,|$)', 'g');
  const obj: any = {};
  var matched = document.cookie.match(pattern)
  if (matched) {
    var cookie = matched[0];
    //console.log('----------find value from string --------------------');
    var zz: any = cookie.split("&").find(function (v) {
      return v.indexOf("groups") > -1;
    });
    //console.log('---------------------final work-------------------------');
    //console.log(zz.split("groups=")[1]);
    var decodestring = decodeURIComponent(zz.split("groups=")[1]);
    decodestring.replace(re, (_, key: any, value: any) => obj[key.trim()] = value.trim());
    //console.log('--------------------obj---------------------------------');
    //console.log(obj);
    if (obj.C0002 == 0 || !isUserOnSearchPage) {
      if (!currentPath) {
        searchInterface.analytics = false; //** testing is the analytics going off or not */
      }
    }
  }

  //cookie workshop
  //** Check In case cookie enabled by user for tracking or not via coveo analytics */

  if (obj.C0002 != 0) {
    //** adding every page analytics for clickable events */
    // console.log('----------Org Id-------------------------------');
    // var yourEndPoint = `https://${organizationId}.analytics.org.coveo.com`;
    // console.log(yourEndPoint);
    const ua = new CoveoAnalyticsClient(
      {
        token: accessToken,
        endpoint: `https://${organizationId}.analytics.org.coveo.com`
      });
    ua.sendViewEvent({
      clientId: await ua.getCurrentVisitorId(),
      contentIdKey: "@clickableuri",
      contentIdValue: window.location.href,
      contentType: currentTemplate
    });
  }

  if (!currentPath) {
    searchInterface.language = currentLanguage;
    dictionaryData.data.forEach((bundle) => {
      searchInterface.i18n.addResourceBundle(
        currentLanguage,
        bundle.bundleKey,
        bundle.bundleValues
      );
    });
        // searchInterface.executeFirstSearch();

    if (isUserOnSearchPage) {
      searchInterface.executeFirstSearch();
    }
  }

  if (currentPath) {
    const searchInterface1: HTMLAtomicSearchInterfaceElement =
      document.querySelector('#interface-1')!;

    const searchInterface2: HTMLAtomicSearchInterfaceElement =
      document.querySelector('#interface-2')!;

    await Promise.all([
      searchInterface1.initialize(config),
      searchInterface2.initialize(config),
    ]);

    searchInterface1.language = currentLanguage;
    dictionaryData.data.forEach((bundle) => {
      searchInterface1.i18n.addResourceBundle(
        currentLanguage,
        bundle.bundleKey,
        bundle.bundleValues
      );
    });

    searchInterface2.language = currentLanguage;
    dictionaryData.data.forEach((bundle) => {
      searchInterface2.i18n.addResourceBundle(
        currentLanguage,
        bundle.bundleKey,
        bundle.bundleValues
      );
    });

    // searchInterface1.executeFirstSearch();
    searchInterface2.executeFirstSearch();

    const engine = buildSearchEngine({
      configuration: {
        organizationId: organizationId,
        accessToken: accessToken,
      }
    });

    const { updateQuerySetQuery } = loadQuerySetActions(engine)

    async function intializeAndSearch() {
      if (engine) {
       searchInterface1.engine?.dispatch(updateQuerySetQuery({ id: Object.keys(searchInterface1.engine.state.querySet!)[0], query: "" }))
      }
    }

    if (currentPath) {
      intializeAndSearch();
    }
  }
}
main();
